export default __webpack_public_path__ + "static/media/BackArrowWhite.fb3b327b.svg";